module.exports = "/_next/static/images/Dana_Singer-535b512dcc6a708c58d242c882564f3d.webp";